import './App.css';
import './LandingPage.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import { useActiveButton } from './ActiveButtonContext';
import { get } from '@aws-amplify/api';

const IronCondorTraditionalMenu = ({ signOut }) => {
  const navigate = useNavigate();
  const { activeButton, setActiveButton } = useActiveButton();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  const navigateTo = (path) => {
    if (path === "/myPortfolioIronCondor") {
      navigate(path, { state: { icType: "SHORT" } });
    } else {
      navigate(path);
    }
  };

  const handleQuickIronCondor = async (security) => {
    setLoading(true);
    setError('');

    try {
      const myAPI = "mktappapi";
      const path = '/getIronCondorOptionsLegsTraditionalWeekly';
      const position = "SHORT";
      const profitAlert = 0;
      const contracts = 1;

      const passApiStr = `${path}/${position}/${security.toUpperCase()}/${profitAlert}/${contracts}`;
      console.log("handleQuickIronCondor : passApiStr = ", passApiStr);

      const response = await get({
        apiName: myAPI,
        path: passApiStr,
      }).response;

      const optionsLegs = await response.body.json();
      console.log("handleQuickIronCondor : optionsLegs = ", optionsLegs);

      setLoading(false);

      if (optionsLegs && Object.keys(optionsLegs).length !== 0) {
        navigate("/ironCondorOptionsLegsTraditionalWeekly", { state: { optionsLegs: optionsLegs } });
      } else {
        setError("No data received from API");
      }
    } catch (err) {
      console.error("handleQuickIronCondor : Error = ", err);
      setError(err.message || "Failed to load data");
      setLoading(false);
    }
  };

  const ActionButton = ({ onClick, title, tooltip, active }) => (
    <button
      onClick={onClick}
      title={tooltip}
      style={{
        padding: '12px 16px',
        background: active ? 'rgba(16, 185, 129, 0.1)' : 'rgba(59, 130, 246, 0.1)',
        border: active ? '1px solid rgba(16, 185, 129, 0.3)' : '1px solid rgba(59, 130, 246, 0.3)',
        borderRadius: '8px',
        color: active ? '#10b981' : '#3b82f6',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s',
        textAlign: 'center',
      }}
      onMouseEnter={(e) => {
        if (!active) {
          e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)';
        }
      }}
      onMouseLeave={(e) => {
        if (!active) {
          e.currentTarget.style.background = 'rgba(59, 130, 246, 0.1)';
        }
      }}
    >
      {title}
    </button>
  );

  return (
    <AppLayout signOut={signOut}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Page Title */}
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)' }}>
            Traditional Iron Condor Strategy
          </h1>
        </div>

        {/* Loading and Error Messages */}
        {loading && (
          <div className="blink_me" style={{
            marginBottom: '16px',
            textAlign: 'center',
            fontSize: '16px',
            padding: '12px',
            background: 'rgba(59, 130, 246, 0.1)',
            borderRadius: '8px'
          }}>
            Getting IC Data...
          </div>
        )}
        {error && (
          <div className="blink_me_red" style={{
            marginBottom: '16px',
            textAlign: 'center',
            fontSize: '16px',
            padding: '12px'
          }}>
            {error}
          </div>
        )}

        {/* Custom Traditional Iron Condor Section */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">🎯 Custom Traditional Iron Condor</h2>
          </div>
          <div className="landing-panel-content">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <ActionButton
                onClick={() => navigateTo('/generateOptionsLegsTraditionalWeekly')}
                title="Generate Weekly Options Legs"
                tooltip="Create custom traditional iron condor with weekly expirations"
              />
            </div>
          </div>
        </div>

        {/* Quick Iron Condor Section */}
        <div className="landing-panel">
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">⚡ Quick Traditional Iron Condor</h2>
          </div>
          <div className="landing-panel-content">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <ActionButton
                onClick={() => handleQuickIronCondor('SPY')}
                title="Short SPY - 1 Contract"
                tooltip="Pre-configured SPY traditional iron condor (SHORT position, 1 contract)"
              />
              <ActionButton
                onClick={() => handleQuickIronCondor('QQQ')}
                title="Short QQQ - 1 Contract"
                tooltip="Pre-configured QQQ traditional iron condor (SHORT position, 1 contract)"
              />
              <ActionButton
                onClick={() => handleQuickIronCondor('IWM')}
                title="Short IWM - 1 Contract"
                tooltip="Pre-configured IWM traditional iron condor (SHORT position, 1 contract)"
              />
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}

export default IronCondorTraditionalMenu;